var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.widget.widgetList.length > 0
    ? _c("smart-widget-grid", {
        attrs: {
          layout: _vm.gridLayout,
          "row-height": 48,
          margin: [15, 15],
          "is-static": true,
          "auto-size": true,
        },
        scopedSlots: _vm._u(
          [
            _vm._l(_vm.widget.widgetList, function (item, index) {
              return {
                key: item.id,
                fn: function () {
                  return [
                    _c(
                      "smart-widget",
                      {
                        attrs: {
                          simple: !item.options.showHeader,
                          title: item.options.label,
                          refresh: item.options.showRefresh,
                          collapse: item.options.showCollapse,
                          fullscreen: item.options.showFullscreen,
                        },
                        on: {
                          "on-refresh": function ($event) {
                            return _vm.onRefresh(item)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "container-com" },
                          [
                            "container" === item.category
                              ? [
                                  _c(item.type + "-item", {
                                    key: item.id,
                                    tag: "component",
                                    attrs: {
                                      layout: _vm.gridLayout,
                                      widget: item,
                                      "parent-list": _vm.widget.widgetList,
                                      "index-of-parent-list": index,
                                      "parent-widget": _vm.widget,
                                    },
                                  }),
                                ]
                              : [
                                  _c(item.type + "-widget", {
                                    key: item.id,
                                    tag: "component",
                                    attrs: {
                                      layout: _vm.gridLayout,
                                      field: item,
                                      "parent-list": _vm.widget.widgetList,
                                      "index-of-parent-list": index,
                                      "parent-widget": _vm.widget,
                                      "design-state": true,
                                    },
                                  }),
                                ],
                          ],
                          2
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              }
            }),
          ],
          null,
          true
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }